var map = {
	"./1.jpg": 1186,
	"./10.jpg": 1837,
	"./11.jpg": 8350,
	"./12.jpg": 6381,
	"./13.jpg": 5319,
	"./14.jpg": 4400,
	"./2.jpg": 3915,
	"./3.jpg": 4828,
	"./4.jpg": 3727,
	"./5.jpg": 1166,
	"./6.jpg": 440,
	"./7.jpg": 4497,
	"./8.jpg": 1266,
	"./9.jpg": 6115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1068;